import { render, staticRenderFns } from "./ShoppingListItem.vue?vue&type=template&id=6b31ec4a&"
import script from "./ShoppingListItem.vue?vue&type=script&lang=js&"
export * from "./ShoppingListItem.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingListItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports